import axios from 'axios'
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export async function getCarByLicensePlate(licensePlate) {
  const result = await axios
    .get(
      `${CATALOGO_ENDPOINT}/getByPatentAndCarlot/${licensePlate}`
    )

  return result?.data
}
